import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

/* Directives */
import { CanNotSeeDirective } from './can-not-see.directive';
import { CanSeeDirective } from './can-see.directive';
import { HideSmDirective } from './hide-sm.directive';
import { CanNotSeeExactDirective } from './can-not-see-exact.directive';
import { TrimFormInputDirective } from './trim-input.directive';
import { TrimInputDirective } from './trim.directive';
import { ResizeTableDirective } from './resize-table.directive';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { TrimOnPasteDirective } from './trim-on-paste.directive';

@NgModule({
  imports: [CommonModule, NgxDatatableModule],
  declarations: [
    CanSeeDirective,
    CanNotSeeDirective,
    HideSmDirective,
    CanNotSeeExactDirective,
    ResizeTableDirective,
    TrimFormInputDirective,
    TrimInputDirective,
    TrimOnPasteDirective
  ],
  exports: [
    CanSeeDirective,
    CanNotSeeDirective,
    HideSmDirective,
    CanNotSeeExactDirective,
    ResizeTableDirective,
    TrimFormInputDirective,
    TrimInputDirective,
    TrimOnPasteDirective
  ],
  providers: []
})
export class DirectivesModule {}
